// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/admin/dashboard',
    icon: icon('ic_analytics'),
  },
  {
    title: 'system',
    path: '/admin/system',
    icon: icon('ic_analytics'),
  },
  {
    title: 'fleet management',
    path: '/admin/fleet',
    icon: icon('ic_analytics'),
  },
  {
    title: 'reads',
    path: '/admin/reads',
    icon: icon('ic_user'),
  },
];

export default navConfig;
